import { useContext } from "react";
import { FirestoreContext } from "../contexts/FirestoreContext";

// ----------------------------------------------------------------------

const useFirestore = () => useContext(FirestoreContext);

export default useFirestore;
